import BulletList from '@tiptap/extension-bullet-list';

export const ContentBulletList = BulletList.extend({
  draggable: true,
});
